import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { config } from './../../config/config';
const { colorConfig } = config();

const Comment = styled.div`
  font-size: 0.8em;
  font-weight: normal;
  color: #4b4b4b;
  white-space: normal;
  padding-right: 0px;

  &.disabled {
    color: #ccc;
  }
`;

const Lbl = ({ onClick, label, comment, disabled, children, color }) => {
  const styleLabel = {
    whiteSpace: 'nowrap', marginLeft: '0px', color: color || '#4b4b4b', // flex: 1
    lineHeight: '2em', marginRight: 0,
    fontWeight: 'normal', fontSize: 14, fontFamily: 'Ubuntu, arial'
  };
  if (disabled) {
    styleLabel.color = '#aaa';
    styleLabel.cursor = 'default';
  }
  return (
    <div onMouseDown={onClick} style={styleLabel}>
      {label}
      <Comment className={disabled ? 'disabled' : ''}>{comment}</Comment>
      {children}
    </div>);
};

/* eslint-disable jsx-a11y/label-has-for */
export const RadioButton = ({ minWidth, value, side, label, comment, children, disabled, checked, onChange, shiftTop, color }) => {
  const onClick = () => { if (!disabled) onChange(value); };
  const styleTop = {
    display: 'flex', alignContent: 'center', alignItems: 'flex-start', padding: '0px 0px', cursor: 'pointer',
    userSelect: 'none', margin: 0, minWidth: minWidth || 80
  };
  const chkAtLeft = (!side || side === 'left');
  const styleCheck = { textAlign: chkAtLeft ? 'left' : 'right', margin: '0px auto' };
  const styleRadioButtonCont = { marginTop: shiftTop || 3 };
  const styleRadioButton = { stroke: '#000', strokeWidth: '1px'};
  if (disabled) {
    styleRadioButton.stroke = '#aaa';
    styleRadioButton.cursor = 'default';
  }
  if (checked) {
    //styleTop.background = '#ede7f3 linear-gradient(#fff 0%, #ede7f3 80%)';
    //styleTop.borderRadius = 4;
    //styleTop.border = '1px #007bff solid';
    //styleTop.borderTop = '1px #6239bf solid';
    //styleTop.borderBottom = '1px #61c38b solid';
  } else {
    // styleTop.border = '1px transparent solid';
  }
  return (
    <label className='radioButton' style={styleTop}>
      {(!chkAtLeft && (label || children)) ? <Lbl {...{ onClick, label, comment, children, disabled, color }} /> : ''}
      <div style={styleCheck} onMouseDown={onClick} >
        <svg width='24' height='24' style={styleRadioButtonCont} >
          <circle cx='12' cy='12' r='10' fill='transparent' style={styleRadioButton} />
          { checked ? <circle cx='12' cy='12' r='7' fill={color || colorConfig.main} fillOpacity='1' /> : ''}
        </svg>
      </div>
      {(chkAtLeft && (label || children)) ? <Lbl {...{ onClick, label, comment, children, disabled, color }} /> : ''}
    </label>
  );
};

RadioButton.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/Form/RadioButton.js